
<div class="authStepContainer" ngStyle.lt-md="height:100%;">
  <div fxLayout="column" fxLayoutAlign="center center">
    <div fxLayout="row">
      <h3>
        Αναγνώριση λογαριασμού 2 βημάτων
      </h3>
    </div>


    <div fxLayout="row" style="margin-top: 40px;">
      <label>
        Παρακαλούμε εισάγετε τον 6 ψήφιο κωδικό που λάβατε στο email σας.
      </label>
    </div>

    <div fxLayout="row wrap" style="margin-top: 50px;">

      <div class="codeHolder">
        <mat-form-field>
          <label>
            <input #n1 type="number" matInput [(ngModel)]="authNumber.num1" [min]="0" [max]="9"
                   oninput="validity.valid||(value='');" (keypress) = "keyFocus($event, 1)">
          </label>
        </mat-form-field>
      </div>

      <div class="codeHolder">
        <mat-form-field>
          <label>
            <input #n2 type="number" matInput [(ngModel)]="authNumber.num2" [min]="0" [max]="9"
                   oninput="validity.valid||(value='');" (keypress) = "keyFocus($event, 2)">
          </label>
        </mat-form-field>
      </div>

      <div class="codeHolder">
        <mat-form-field>
          <input #n3 type="number" matInput [(ngModel)]="authNumber.num3" [min]="0" [max]="9"
                 oninput="validity.valid||(value='');" (keypress) = "keyFocus($event, 3)">
        </mat-form-field>
      </div>

      <div class="codeHolder" ngStyle.lt-md="margin-top:5px">
        <mat-form-field>
          <label>
            <input #n4 type="number" matInput [(ngModel)]="authNumber.num4" [min]="0" [max]="9"
                   oninput="validity.valid||(value='');" (keypress) = "keyFocus($event, 4)">
          </label>
        </mat-form-field>
      </div>

      <div class="codeHolder" ngStyle.lt-md="margin-top:5px">
        <mat-form-field>
          <label>
            <input #n5 type="number" matInput [(ngModel)]="authNumber.num5" [min]="0" [max]="9"
                   oninput="validity.valid||(value='');" (keypress) = "keyFocus($event, 5)">
          </label>
        </mat-form-field>
      </div>

      <div class="codeHolder" ngStyle.lt-md="margin-top:5px">
        <mat-form-field>
          <label>
            <input #n6 type="number" matInput [(ngModel)]="authNumber.num6" [min]="0" [max]="9"
                   oninput="validity.valid||(value='');">
          </label>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center" style="margin-top:50px;">
      <button  [disabled]="filledNumbers() || loading" mat-raised-button id="buttonLogin" [class.spinner]="loading" color="primary" (click)="checkCode()">
        <span id="buttonText">Επαλήθευση</span>
      </button>
    </div>
  </div>
</div>
